module.exports = function() {
  return new Worker(__webpack_public_path__ + "54331080eaf5803c82b2.worker.js");
};